module.exports = "/images/side-reports-active.svg?8af34fbbe61fcec229da19228f0ebe15";